import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DETALLE_BANK } from 'src/app/services/constant-services.data';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-modal-debito-resumen',
  templateUrl: './modal-debito-resumen.component.html',
  styleUrls: ['./modal-debito-resumen.component.scss'],
})
export class ModalDebitoResumenComponent implements OnInit {
  icon: string;
  bank: any;
  coin: any;
  cuerpo: any;
  modalidad:any;
  tipoCuenta:any;
  banco:any;
  frecuencia:any;
  fondoNombre:any;
  objetivo:any;
  otros:any;
  monto:any;
  comision:any;
  total:any;
  moneda:any;
  fecha:any;
  fechaVen:any;
  numeroCuentaFormateado: any;
  numeroTarjetaFormateado: any;
  constructor(
    public globalService: GlobalService,
    public dialogRef: MatDialogRef<ModalDebitoResumenComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      icon: string
      title: string
      content: string
      bold: string
      cancelbtn: string
      confirmbtn: string
      bullet: any
      coin: string
      cuerpo:any
    }
  ) {}

  ngOnInit() {
    this.bank = DETALLE_BANK
    this.icon= this.data.icon?this.data.icon: 'info'
    this.coin= this.data.coin;
    this.cuerpo= this.data.cuerpo;

    this.fecha = this.cuerpo.fechaAfiliacion.substring(8,10)+'-'+this.cuerpo.fechaAfiliacion.substring(5,7)+'-'+this.cuerpo.fechaAfiliacion.substring(0,4);

    if(this.cuerpo.modalidadPago === 'BAN'){
      this.modalidad ='CARGO EN CUENTA BANCARIA'
    }
    else{
      this.modalidad='CARGO EN TARJETA DE CRÉDITO VISA'
    }

    if(this.cuerpo.modalidadPago === 'BAN'){
      this.modalidad ='CARGO EN CUENTA BANCARIA'
    }
    else{
      this.modalidad='CARGO EN TARJETA DE CRÉDITO VISA'
      this.fechaVen = this.cuerpo.fechaVencimiento.substring(0,2)+'/'+this.cuerpo.fechaVencimiento.substring(2,4);
    }



    if(this.cuerpo.tipoCuenta === '001'){
      this.tipoCuenta ='Ahorros Dólares'
    }
    else if(this.cuerpo.tipoCuenta === '005'){
      this.tipoCuenta ='Cta. Corriente Dólares'
    }
    else if(this.cuerpo.tipoCuenta === '008'){
      this.tipoCuenta ='CTA. MAESTRA DÓLARES'
    }

    else if(this.cuerpo.tipoCuenta === '002'){
      this.tipoCuenta ='Cta. Corriente Soles'
    }
    else if(this.cuerpo.tipoCuenta === '003'){
      this.tipoCuenta ='CTA. MAESTRA SOLES'
    }
    else if(this.cuerpo.tipoCuenta === '004'){
      this.tipoCuenta ='Ahorros Soles'
    }

    if(this.cuerpo.codigoBanco === '001'){
      this.banco ='BCP'
    }
    else if(this.cuerpo.codigoBanco === '003'){
      this.banco ='BBVA'
    }
    else if(this.cuerpo.codigoBanco === '002'){
      this.banco ='Scotiabank'
    }

    if(this.cuerpo.fondo === '15'){
      this.moneda ='S/'
      this.fondoNombre ='Fondo de Fondos SURA Capital Estratégico I FMIV serie B'
    }
    else if(this.cuerpo.fondo === '17'){
      this.moneda ='S/'
      this.fondoNombre ='Fondo de Fondos SURA Capital Estratégico II FMIV serie B'
    }
    else if(this.cuerpo.fondo === '34'){
      this.moneda ='US$'
      this.fondoNombre ='Fondo de Fondos SURA Selección Global I FMIV serie B'
    }


    if(this.cuerpo.tipoPlan === '002'){
      this.objetivo ='SALUD'
    }
    else if(this.cuerpo.tipoPlan === '003'){
      this.objetivo ='CASA PROPIA'
    }
    else if(this.cuerpo.tipoPlan === '004'){
      this.objetivo ='EDUCACION'
    }
    else if(this.cuerpo.tipoPlan === '005'){
      this.objetivo ='NEGOCIO PROPIO'
    }
    else if(this.cuerpo.tipoPlan === '006'){
      this.objetivo ='JUBILACION'
    }
    else if(this.cuerpo.tipoPlan === '008'){
      this.objetivo ='OTROS'
    }
    
    if((this.cuerpo.modalidadPago === 'BAN') && (this.cuerpo.fondo === '15' || this.cuerpo.fondo === '17')){
        if(this.cuerpo.codigoBanco === '001'){
          this.comision ='S/5.00';
          this.total =  this.moneda + (Number(this.cuerpo.monto) + Number(5.0)).toFixed(2);
        }
        else if(this.cuerpo.codigoBanco === '003'){
          this.comision ='S/3.00';
          this.total = this.moneda + (Number(this.cuerpo.monto) + Number(3.0)).toFixed(2);
        }
        else if(this.cuerpo.codigoBanco === '002'){
          this.comision ='S/5.00';          
          this.total = this.moneda + (Number(this.cuerpo.monto) + Number(4.0)).toFixed(2);
        }
    }

    if((this.cuerpo.modalidadPago === 'BAN') && (this.cuerpo.fondo === '34')){
      if(this.cuerpo.codigoBanco === '001'){
        this.comision ='US$1.80';
        this.total = this.moneda + (Number(this.cuerpo.monto) + Number(1.8)).toFixed(2);
      }
      else if(this.cuerpo.codigoBanco === '003'){
        this.comision ='US$1.50';
        this.total = this.moneda + (Number(this.cuerpo.monto) + Number(1.5)).toFixed(2);
      }
      else if(this.cuerpo.codigoBanco === '002'){
        this.comision ='US$1.80';
        this.total = this.moneda + (Number(this.cuerpo.monto) + Number(1.2)).toFixed(2);
      }
    }

    if(this.cuerpo.modalidadPago === 'TAR'){
      this.comision = (0.0259 * Number(this.cuerpo.monto))/0.9741;
      //this.comision = this.cuerpo.monto * 0.0259;
      this.total = this.moneda + (Number(this.cuerpo.monto) + Number(this.comision)).toFixed(2);
      this.comision = this.moneda +  (Number(this.comision)).toFixed(2);
    }

    this.monto = this.moneda + Number(this.cuerpo.monto).toFixed(2);

    this.numeroCuentaFormateado = this.formatoNumeroCuenta (this.cuerpo.numeroCuenta,this.cuerpo.codigoBanco,this.cuerpo.tipoCuenta);
    this.numeroTarjetaFormateado = this.format(this.cuerpo.numeroTarjeta,'****-****-****-****');
/***
    this.banco:any;
    this.frecuencia:any;
    this.fondoNombre:any;
    this.objetivo:any;
    this.otros:any;
 */

  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel(){
    this.dialogRef.close(false);
  }

  formatoNumeroCuenta(numero: string,banco: string, cuenta: String){

    if(banco ==='001' && (cuenta ==='001' || cuenta ==='004')){
      return this.format(numero,'***-********-*-**');
    }

    if(banco ==='001' && (cuenta ==='002' || cuenta ==='005')){
      return this.format(numero,'***-*******-*-**');
    }

    if(banco ==='001' && (cuenta ==='003' || cuenta ==='008')){
      return this.format(numero,'***-*******-*-**');
    }

    if(banco ==='003' && (cuenta ==='001' || cuenta ==='004' || cuenta ==='002' || cuenta ==='005')){
      return this.format(numero,'****-****-**********');
    }

    if(banco ==='002' && (cuenta ==='001' || cuenta ==='004' || cuenta ==='002' || cuenta ==='005')){
      return this.format(numero,'***-*******');
    }

  }

  format(number, mask) {
    var s = ''+number, r = '';
    for (var im=0, is = 0; im<mask.length && is<s.length; im++) {
      r += mask.charAt(im)=='*' ? s.charAt(is++) : mask.charAt(im);
    }
    return r;
  }   
  
}
